import Axios from "../../../../api/axios/Axios";

const base = "/api/talent/profiles";

const talentUrl = (talentId) => `${base}/${encodeURIComponent(talentId)}`;

const resourceUrl = (talentId, resource) =>
  `${talentUrl(talentId)}/${resource}`;

export const getMyTalent = () => Axios.get(`${base}/mine`);

export const getTalent = (talentId) => Axios.get(talentUrl(talentId));

export const createTalent = (data) => Axios.post(base, data);

export const updateTalent = (talentId, data) =>
  Axios.put(talentUrl(talentId), data);

export const deleteTalent = (talentId) => Axios.delete(talentUrl(talentId));

export const updateTalentPhoto = (talentId, filename) =>
  Axios.put(resourceUrl(talentId, "photo"), { filename });

export const getTalentSports = (talentId) =>
  Axios.get(resourceUrl(talentId, "sports"));

export const addTalentSport = (talentId, data) =>
  Axios.post(resourceUrl(talentId, "sports"), data);

export const updateTalentSport = (talentId, sportId, data) =>
  Axios.put(
    `${resourceUrl(talentId, "sports")}/${encodeURIComponent(sportId)}`,
    data,
  );

export const deleteTalentSport = (talentId, sportId) =>
  Axios.delete(
    `${resourceUrl(talentId, "sports")}/${encodeURIComponent(sportId)}`,
  );

export const setPrimaryTalentSport = (talentId, sportId) =>
  Axios.put(
    `${resourceUrl(talentId, "sports")}/${encodeURIComponent(sportId)}/primary`,
  );

export const getTalentExperiences = (talentId) =>
  Axios.get(resourceUrl(talentId, "experiences"));

export const addTalentExperience = (talentId, data) =>
  Axios.post(resourceUrl(talentId, "experiences"), data);

export const updateTalentExperience = (talentId, id, data) =>
  Axios.put(
    `${resourceUrl(talentId, "experiences")}/${encodeURIComponent(id)}`,
    data,
  );

export const deleteTalentExperience = (talentId, id) =>
  Axios.delete(
    `${resourceUrl(talentId, "experiences")}/${encodeURIComponent(id)}`,
  );

export const getTalentAchievements = (talentId) =>
  Axios.get(resourceUrl(talentId, "achievements"));

export const addTalentAchievement = (talentId, data) =>
  Axios.post(resourceUrl(talentId, "achievements"), data);

export const updateTalentAchievement = (talentId, id, data) =>
  Axios.put(
    `${resourceUrl(talentId, "achievements")}/${encodeURIComponent(id)}`,
    data,
  );

export const deleteTalentAchievement = (talentId, id) =>
  Axios.delete(
    `${resourceUrl(talentId, "achievements")}/${encodeURIComponent(id)}`,
  );

export const getTalentMedia = (talentId) =>
  Axios.get(resourceUrl(talentId, "media"));

export const addTalentMedia = (talentId, data) =>
  Axios.post(resourceUrl(talentId, "media"), data);

export const updateTalentMedia = (talentId, mediaId, data) =>
  Axios.put(
    `${resourceUrl(talentId, "media")}/${encodeURIComponent(mediaId)}`,
    data,
  );

export const deleteTalentMedia = (talentId, mediaId) =>
  Axios.delete(
    `${resourceUrl(talentId, "media")}/${encodeURIComponent(mediaId)}`,
  );
